module.exports = __webpack_public_path__ + "img/avatar-549.6be0197f.png";